import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Cookies from "js-cookie";

import * as AuthServices from '../services/auth.service';
import { ATLEAST_ONE_CAPITAL_REGEX, ATLEAST_ONE_NUMBER_REGEX, ATLEAST_ONE_SMALL_REGEX, ATLEAST_ONE_SPECIAL_CHARACTER_REGEX, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, SWAL_SETTINGS } from "../../../utils/Constants";
import { PHONE_VALIDATION } from "../../../utils/CommonValidatiobn";
import Swal from "sweetalert2";
import { handleServerValidations, removeSessionKey, setLocalKey, setSessionKey } from "../../../utils/commonfunction";
import { useDispatch } from "react-redux";
import { addProfileData } from "../../../redux/slices/profileslice";
import { useNavigate, useSearchParams } from "react-router-dom";
import PhoneInput from "../../../utils/PhoneInput";

function ResetPasswordAdvertiser() {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [showPassword, setShowPassword] = useState(false); // State to manage password visibility (for demonstration)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(()=>{
    AuthServices
    .VerifyResetToken(searchParams.get('reset_token'))
    .then((response) => {
      setSubmitted(true);

      if (response.success) {
      
      } else {
        Swal.fire({
          icon: "error",
          text: handleServerValidations(response),
          ...SWAL_SETTINGS,
        });
        navigate('../login');
      }
    })
    .catch((error) => {
      setSubmitted(true);
      console.log("error ====> ", error);

      Swal.fire({
        icon: "error",
        text: handleServerValidations(error),
        ...SWAL_SETTINGS,
      });
      navigate('../login');
    });

  }, [])
  
  const validationSchema = Yup.object().shape({
      password: Yup.string()
          .required("New password is required")
          .matches(ATLEAST_ONE_SMALL_REGEX, "Password should have at least 1 lowercase letter")
          .matches(ATLEAST_ONE_CAPITAL_REGEX, "Password should have at least 1 capital letter")
          .matches(ATLEAST_ONE_NUMBER_REGEX, "Password should have at least 1 number")
          .matches(ATLEAST_ONE_SPECIAL_CHARACTER_REGEX, "Password should have at least 1 special character")
          .min(PASSWORD_MIN_LENGTH, "Password should be at least 8 characters long")
          .max(PASSWORD_MAX_LENGTH, "Password cannot be more than 20 characters long"),
      confirm_password: Yup.string().required("Confirm password is required").oneOf([Yup.ref("password"), null], "Passwords don't match")
    });
  
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
          password: '',
          confirm_password: '',
        },
        validationSchema: validationSchema,
        validateOnBlur: false,
        onSubmit: (values, { setSubmitting, resetForm }) => {
          
          let formData = new FormData();
          formData.append("reset_token", searchParams.get('reset_token'))
          formData.append("password", values.password);
          formData.append("confirm_password", values.confirm_password);
         
          setSubmitted(false);
          AuthServices
            .ResetPassword(formData)
            .then((response) => {
              setSubmitted(true);
  
              if (response.success) {
                Swal.fire({
                  icon: "success",
                  text: response.message,
                  ...SWAL_SETTINGS,
                });
                navigate('../login');
              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
              }
            })
            .catch((error) => {
              setSubmitted(true);
              console.log("error ====> ", error);
            });
        },
    });

  return (
    <section className="py-8 md:py-12 lg:py-16 form-bg">
      <div className="container">
        <div className="mb-8">
          <h1 className="headings-h1 text-center text-zinc-950 mb-2">
            Reset Password
          </h1>
          <p className="text-center text-zinc-500 body-lg">
            Enter the new password
          </p>
        </div>
        <div className="bg-white p-[15px] md:p-[50px] rounded-[10px] max-w-[475px] shadow-[0px_2px_24px_rgba(0,0,0,0.05)] w-full mx-auto border border-zinc-100 w-full">
          <form onSubmit={formik.handleSubmit} className="space-y-5">
            <div className="form-group">
              <label htmlFor="password" className="">
                New Password
              </label>
              <div className="relative">
                <input
                  id="password"
                  type={showPassword ? 'text' : "password"}
                  placeholder="Enter new password"
                  className="form-control-custom !pr-[40px]"
                  // required
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                  onClick={() =>setShowPassword(prev => !prev)}
                >
                  {showPassword ? <img src="/images/eye2.svg" /> : <img src="/images/eye1.svg" />}
                </button>
              </div>
              <span className="text-danger text-left d-blockerr-spn">
                {formik.errors.password && formik.touched.password && formik.errors.password}
              </span>
            </div>
            <div className="form-group">
              <label htmlFor="confirm_password" className="">
                Confirm New Password
              </label>
              <div className="relative">
                <input
                  id="confirm_password"
                  type={showConfirmPassword ? 'text' : "password"}
                  placeholder="Enter confirm new password"
                  className="form-control-custom !pr-[40px]"
                  // required
                  name="confirm_password"
                  value={formik.values.confirm_password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                  onClick={()=> setShowConfirmPassword(prev => !prev)}
                >
                  {showConfirmPassword ? <img src="/images/eye2.svg" /> : <img src="/images/eye1.svg" />}
                </button>
              </div>
              <span className="text-danger text-left d-blockerr-spn">
                {formik.errors.confirm_password && formik.touched.confirm_password && formik.errors.confirm_password}
              </span>
            </div>
            <button type="submit" className="btn btn-pri w-full mt-4">
              Submit
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ResetPasswordAdvertiser;
